import React from "react";
import Img from "gatsby-image";
import { Link } from "gatsby";
// import { normalizeTwoWords, findRel } from "../../../shared/utils/stringUtilities";

import "./presenter.scss";
// import Author from "../author/author";
// import { adapterAuthor } from "../../templates/library-components/adapters";

interface PresenterInterface {
  title: string;
  subtitle: any;
  buttonName: string;
  buttonLink: string;
  className?: string;
  bookImage?: any;
  categoryName?: string;
  generalTitle?: string;
  author?: any
}

const Presenter = (props: PresenterInterface) => {
  return (
    <article
      className={`m-presenter ${props.className || ""} ${
        props.bookImage ? "m-presenter-book" : ""
      }`}
    >
      {props.bookImage && (
        <div className="m-presenter-book__cover-side">
          {props.bookImage.fluid ? (
            <Img
              className="m-presenter-book__cover-side__image"
              fluid={props.bookImage.fluid}
              alt={props.bookImage.title || `Imagen ${props.title}`}
            />
          ) : (
            <img
              className="m-presenter-book__cover-side__image"
              src={props.bookImage.file.url}
              alt={props.bookImage.title || `Imagen ${props.title}`}
            />
          )}
        </div>
      )}
      <div
        className={`m-presenter__info-side ${
          props.bookImage ? "m-presenter__info-side__book" : ""
        }`}
      >
        <p
          className={`title ${
            props.bookImage ? "m-presenter__info-side__book-name" : ""
          }`}
        >
          <Link to={props.buttonLink} dangerouslySetInnerHTML={{ __html: props.title }}>
          </Link>
        </p>
        {!props.bookImage && (
          <div className="subtitle hide-on-mobile">{props.subtitle}</div>
        )}
        {
          /*props.buttonName && (
          <a 
            href={props.buttonLink} 
            className={`button gtm${normalizeTwoWords(props.categoryName)}${normalizeTwoWords(props.generalTitle)}${normalizeTwoWords(props.title)}Btn`}
            rel={findRel(props.buttonLink)}
          >
            {props.buttonName*}
          </a>
        )*/
          // <Author {...adapterAuthor(props.author)} />

        }
      </div>
    </article>
  );
};

export default Presenter;
